import { configureStore } from '@reduxjs/toolkit';
import leftNavigationTabSlice from './reducers/leftNavigationTabSlice';
import openContractSlice from './reducers/openContractSlice';
import contractIdSlice from './reducers/contractIdSlice';
import contractDetailDataSlice from './reducers/contractDetailDataSlice';
import snackBarMessageSlice from './reducers/snackbar/snackBarMessageSlice';
import snackBarMessageTypeSlice from './reducers/snackbar/snackBarMessageTypeSlice';
import snackBarOpenSlice from './reducers/snackbar/snackBarOpenSlice';
import openDialogSbpSlice from './reducers/openDialogSbpSlice';
import openDialogRegisterSlice from './reducers/openDialogRegisterSlice';
import configSlice from './reducers/configSlice';
import appealAttachedFilesSlice from './reducers/appealAttachedFilesSlice';
import getContragentSlice from './reducers/getContragentSlice';
import getContragentAllDataSlice from './reducers/getContragentAllDataSlice';
import openChatWootSlice from './reducers/openChatWootSlice';
import getContractSlice from './reducers/getContractSlice';
import storyPaymentReceiptResponseStatusSlice from './reducers/storyPaymentReceiptResponseStatusSlice';
import openDialogMeteringDeviceAdditionalSlice from './reducers/openDialogMeteringDeviceAdditionalSlice';

export const store = configureStore({
 reducer: {
  leftNavigationTab: leftNavigationTabSlice,
  openContract: openContractSlice,
  contractId: contractIdSlice,
  contractDetailData: contractDetailDataSlice,
  snackBarMessage: snackBarMessageSlice,
  snackBarMessageType: snackBarMessageTypeSlice,
  snackBarOpen: snackBarOpenSlice,
  openDialogSbp: openDialogSbpSlice,
  openDialogRegister: openDialogRegisterSlice,
  config: configSlice,
  appealAttachedFiles: appealAttachedFilesSlice,
  getContragent: getContragentSlice,
  getContragentAllData: getContragentAllDataSlice,
  openChatWoot: openChatWootSlice,
  getContract: getContractSlice,
  storyPaymentReceiptResponseStatus: storyPaymentReceiptResponseStatusSlice,
  openDialogMeteringDeviceAdditional: openDialogMeteringDeviceAdditionalSlice,
 },
 middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
   serializableCheck: false,
  }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
